import { render } from "./AppsButton.vue?vue&type=template&id=ead362fc&scoped=true&ts=true"
import script from "./AppsButton.vue?vue&type=script&lang=ts"
export * from "./AppsButton.vue?vue&type=script&lang=ts"

import "./AppsButton.vue?vue&type=style&index=0&id=ead362fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ead362fc"],['__file',"src/components/list-items/AppsButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ead362fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ead362fc', __exports__)) {
    api.reload('ead362fc', __exports__)
  }
  
  module.hot.accept("./AppsButton.vue?vue&type=template&id=ead362fc&scoped=true&ts=true", () => {
    api.rerender('ead362fc', render)
  })

}


export default __exports__